import { render, staticRenderFns } from "./fixed.vue?vue&type=template&id=1237d1a3&scoped=true&"
import script from "./fixed.vue?vue&type=script&lang=js&"
export * from "./fixed.vue?vue&type=script&lang=js&"
import style0 from "./fixed.vue?vue&type=style&index=0&id=1237d1a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1237d1a3",
  null
  
)

export default component.exports